import { render, staticRenderFns } from "./ContentPerformanceView.vue?vue&type=template&id=a55c4baa&scoped=true"
import script from "./ContentPerformanceView.vue?vue&type=script&lang=js"
export * from "./ContentPerformanceView.vue?vue&type=script&lang=js"
import style0 from "./ContentPerformanceView.vue?vue&type=style&index=0&id=a55c4baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55c4baa",
  null
  
)

export default component.exports